const teamCreateSchema = {
    title: {
        type: "string",
        required: true,
        length: {
            min: 1,
            max: 256
        },
        displayName: "Título"
    },
    parentTeamId: {
        type: "integer",
        required: false,
        displayName: "Equipo padre"
    },
    leaderId: {
        type: "integer",
        required: false,
        displayName: "Leader"
    },
    specialistId: {
        type: "integer",
        required: false,
        displayName: "Especialista"
    }
}
 
const addTeamMemberSchema = {
    userId: {
        type: "integer",
        required: true,
        displayName: "Usuario"
    },
    dataRoleId: {
        type: "integer",
        required: true,
        displayName: "Data Role"
    }
}

const teamUpdateSchema = {
    title: {
        type: "string",
        required: true,
        length: {
            min: 1,
            max: 256
        },
        displayName: "Título"
    },
    parentTeamId: {
        type: "integer",
        required: false,
        displayName: "Equipo padre"
    },
    specialistId: {
        type: "integer",
        required: false,
        displayName: "Especialista"
    },
    allowLeaderEdition: {
        type: "integer",
        required: true,
        displayName: "Allow edition to leader"
    }
}

const teamAccountabilitySchema = {
    time: {
        type: "string",
        required: true,
        length: {
            min: 1,
            max: 8
        },
        displayName: "Hora"
    },
    day: {
        type: "integer",
        required: true,
        displayName: "Día"
    }
}

export {
    teamCreateSchema,
    addTeamMemberSchema,
    teamUpdateSchema,
    teamAccountabilitySchema
};
